import { render, staticRenderFns } from "./BankTransferMethod.vue?vue&type=template&id=178635d5&scoped=true"
import script from "./BankTransferMethod.vue?vue&type=script&lang=js"
export * from "./BankTransferMethod.vue?vue&type=script&lang=js"
import style0 from "./BankTransferMethod.vue?vue&type=style&index=0&id=178635d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178635d5",
  null
  
)

export default component.exports